
<countdown #cd [config]="config" (event)="handleEvent($event)" class="countdown" (notify)="handleEvent($event)"></countdown>

<countdown #cycle [config]="cycleConfig" (event)="handleCycleEvent($event)" class="countdown" (notify)="handleCycleEvent($event)"></countdown>

